import React, { useEffect } from "react";
import StoreEmployeeList from "../StoreEmployeeList";
import { useListStoreUsers } from "../../../hooks/api/useStore";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import CommonLoader from "../../common/CommonLoader/CommonLoader";
import { Employee } from "../../Employees/types/employees";
import NoEmployeeListFound from "../../Employees/NoEmployeeListFound";

interface Props {
  storeId: string;
}

const StoreEmployeesTab: React.FC<Props> = ({ storeId }) => {
  const storesEmployees = useSelector(
    (state: RootState) => state.store.storeUsers
  );

  const { mutate: listStoreUsers, isError, isPending } = useListStoreUsers();

  useEffect(() => {
    if (storeId) {
      listStoreUsers({
        storeIds: [storeId]
      });
    }
  }, [storeId, listStoreUsers]);

  if (isPending) return <CommonLoader loadingMessage="Loading Store users" />;

  if (isError) {
    return <NoEmployeeListFound />;
  }

  // Use Redux state instead of mutation data
  return <StoreEmployeeList storesEmployees={storesEmployees as Employee[]} />;
};

export default StoreEmployeesTab;
